<template>
  <form class="form">
    <FormInput :label="$t('form.label.notice.title')" v-model="form.fields.title" name="title" required/>
    <FormMultipleFile :label="`${$t('form.label.images')}`" v-model="form.fields.images" name="images" :maxSize="5000"
      accept=".png,.jpg,.jpeg" :multiple="6"
      :message="`${$t('form.messages.notice.images')} ${$t('form.messages.png_jpg')}`" />
    <FormWysiwyg :label="$t('form.label.notice.text')" v-model="form.fields.text" name="text" required/>
  </form>
</template>

<script>
import {FormMultipleFile, FormInput, FormWysiwyg} from '@/components/form/fields'
import FormValidMixin from '@/components/form/mixins/FormValidMixin.js'

export default {
  name: 'AddEditNotice',
  mixins: [FormValidMixin],
  components: {
    FormMultipleFile,
    FormInput,
    FormWysiwyg
  },
  data() {
    return {
      form: {
        fields: {
          user_id: {
            value: 0,
            valid: true
          },
          title: {
            value: '',
            valid: false
          },
          images: {
            file: [],
            previewName: '',
            previewUrl: null,
            value: '',
            valid: false
          },
          text: {
            value: '',
            valid: false
          }
        },
        submitted: false
      }
    }
  },
  methods: {
    messageToTooltip() {
      const title = this.form.fields.title.value

      if (this.$route.query.action === this.$query.ACTION.EDIT) {
        return this.$popup.report(`${title} ${this.$t('popup.modifiedElement')}`, false)
      }

      this.$popup.report(`${title} ${this.$t('popup.createdElement')}`, false)
    },
    async submit() {
      this.form.fields.user_id.value = this.$auth.user.id

      if (this.form.valid) {
        this.form.submitted = true
        const formData = Object.entries(this.form.fields).reduce((acc, [fieldName, field]) => {
          acc[fieldName] = field.value

          return acc
        }, {})

        let currentId
        this.$route.query.action === this.$query.ACTION.EDIT
            ? currentId = await this.$notice.update(this.$route.query.id, formData)
            : currentId = await this.$notice.store(formData)

        const imageItems = this.form.fields.images.file || []

        const newFiles = imageItems.filter(item => item instanceof File)

        const existingIds = imageItems
          .filter(item => !(item instanceof File) && item.id)
          .map(item => item.id)

        await this.$notice.uploadImages(currentId, {
          newFiles,
          existingIds
        })

        this.form.submitted = false

        this.messageToTooltip()
      }
    }
  },
  mounted() {
    if (this.$route.query.action === this.$query.ACTION.EDIT && this.$notice.all) {
      const notice = this.$notice.all.find(({id}) => id.toString() === this.$route.query.id)

      if (notice) {
        this.form.fields.title = {valid: true, value: notice.title}
        this.form.fields.images = {valid: true, value: notice.images, file: notice.images}
        this.form.fields.text = { valid: true, value: notice.text }

        this.form.fields.images.previewName = `(${notice.images.length}) ` + notice.images.map(({name}) => name).join(', ')
      }
    }
  }
}
</script>